import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import GetZone from '../QrScanner/GetZone.vue'
import QrScanner from '../QrScanner/QrScanner.vue'
import RegisterOrder from '../RegisterOrder/RegisterOrder.vue'
import { scopedTranslation } from '../../i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { sT } = scopedTranslation('newOrder')
const originZoneIdentifier = ref('')
const fullContainerIdentifier = ref('')
const fetchedOriginZone = ref(false)
const fetchedFullContainer = ref(false)
const orderCreated = ref(false)

const setFetchedContainer = (containerType: string) => {
  if (containerType === 'full') {
    fetchedFullContainer.value = true
  }
}

const setFetchedPlace = (zoneType: string) => {
  if (zoneType === 'origin') {
    fetchedOriginZone.value = true
  }
}

const setOrderCreated = () => {
  orderCreated.value = true
}
const resetScanner = () => {
  originZoneIdentifier.value = ''
  fullContainerIdentifier.value = ''
  fetchedOriginZone.value = false
  fetchedFullContainer.value = false
  orderCreated.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!fetchedOriginZone.value)
      ? (_openBlock(), _createBlock(GetZone, {
          key: 0,
          scannerTitle: _unref(sT)('scanOriginZone'),
          onZoneFetched: _cache[0] || (_cache[0] = ($event: any) => (originZoneIdentifier.value = $event))
        }, null, 8, ["scannerTitle"]))
      : (!fetchedFullContainer.value)
        ? (_openBlock(), _createBlock(QrScanner, {
            key: 1,
            title: _unref(sT)('scanFullContainer'),
            onIdFound: _cache[1] || (_cache[1] = ($event: any) => (fullContainerIdentifier.value = $event))
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
    _createVNode(RegisterOrder, {
      onFetchedContainer: setFetchedContainer,
      onFetchedPlace: setFetchedPlace,
      onCreatedOrder: setOrderCreated,
      onReset: resetScanner,
      fullContainerIdentifier: fullContainerIdentifier.value,
      originZoneIdentifier: originZoneIdentifier.value
    }, null, 8, ["fullContainerIdentifier", "originZoneIdentifier"])
  ], 64))
}
}

})